<template>
<div id="news">
    <div class="info title clearfix" style="background: url(/static/img/general/news-fon.png) 0 0 no-repeat;">
        <div class="wrapper clearfix">
            <div style="width: 540px;margin: 70px auto;">
                <router-link class="vbtn active" to="/news/" style="margin-right: 20px;">Новости</router-link>
                <router-link class="vbtn" to="/blog/" style="margin-right: 20px;">Блог</router-link>
                <router-link class="vbtn" to="/sovety-avtovladelcam/">Советы по ремонту авто</router-link>
            </div>
        </div>
    </div>
    <div class="wrapper clearfix">
        <div class="col-md-120 no-padding" id="newslist">
            <div class="col-sm-60 col-xs-120 new" v-for="post in posts" :key="post.id">
                <div class="img_wrap col-sm-40" :style="[ !post.img ? {background: '#333'} : {background: 'url(' + post.img + ') 0 0 no-repeat', backgroundSize: '100% 100%'}]">
                    </div>
                    <div class="col-sm-80">
                        <div class="title">{{post.title}}</div>
                        <div class="date">{{post.date_create}}</div>
                        <div class="wrapper">
                            <div class="col-xs-120 no-padding">
                                <div class="text"><span>{{post.short}}..</span><router-link class="show_more_link" :to="post.link">подробнее</router-link></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'News',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      posts: []
    }
  },
  created () {
    axios.get('https://crm.v-avtoservice.com/list/site-news-list?lang=' + this.city.lang + '&city=' + this.city.id).then(response => {
      this.posts = response.data
    })
  }
}
</script>

<style scoped>
    #newslist {margin: 35px 0;}
    #newslist .img_wrap{height: 150px;padding: 0;}
    #newslist .new:after{clear: both;content: '';display: block;}
    #newslist .new{margin-bottom: 20px;}
    #newslist .new .title{font-weight: 600;font-size: 15px}
    #newslist .new .date{color: #b2b2b2;margin-bottom: 15px;}
    #newslist .new .text {line-height: 1.2;}
</style>



// WEBPACK FOOTER //
// src/components/News.vue